import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0124d255"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Tap any color which doesn't quite match the vibe! ", -1))
const _hoisted_2 = {
  class: "flex-centered",
  style: {"height":"100%"}
}

import * as GameTypes from 'types/game.types';
import { ref } from 'vue';
import { useModule } from 'src/modules/modules';
import { getColorWithSimilarityInRange, getRandomNonUglyColor } from 'util/color-util';
import GameContentArea from '../game-content-area.vue';
import ColorPicker from '../color-picker.vue';
import chroma from 'chroma-js';
import shuffle from 'lodash/shuffle';
import { ascending } from 'util/audio-util';


export default /*#__PURE__*/_defineComponent({
  __name: 'odd-man-out',
  props: {
    difficulty: {
        type: Number,
        default: 0
    }
},
  emits: ['next', 'fail'],
  setup(__props, { expose, emit }) {

const props = __props

const { game, audio } = useModule();
const tones = ascending('FX_ascending_', 1, 8);




const nonTargetColor = ref(getRandomNonUglyColor());
const targetColors = ref<chroma.Color[]>([]);
const nonTargetColors = ref<chroma.Color[]>([]);
const combinedColors = ref<chroma.Color[]>([]); 
const selectedCount = ref(0);
const state = ref({
    distanceMin: 20,
    distanceMax: 25,
    targetDistanceMin: 90,
    targetDistanceMax: 100,
    targetCount: 1,
    nonTargetCount: 7,
    duration: 5000
})



/**
 * Select from a large number of not similar colors
 */
const variation1 = () => {
     if (props.difficulty === 0){
        state.value = {
            distanceMin: 15,
            distanceMax: 20,
            targetDistanceMin: 80,
            targetDistanceMax: 90,
            targetCount: 1,
            nonTargetCount: 7,
            duration: 5000
        }
    } else if (props.difficulty === 1){
        state.value = {
            distanceMin: 20,
            distanceMax: 30,
            targetDistanceMin: 75,
            targetDistanceMax: 90,
            targetCount: 3,
            nonTargetCount: 17,
            duration: 5000
        }
    } else if (props.difficulty === 2){
        state.value = {
            distanceMin: 20,
            distanceMax: 30,
            targetDistanceMin: 75,
            targetDistanceMax: 90,
            targetCount: 5,
            nonTargetCount: 15,
            duration: 7000
        }
    } else if (props.difficulty === 3){
        state.value = {
            distanceMin: 20,
            distanceMax: 30,
            targetDistanceMin: 60,
            targetDistanceMax: 90,
            targetCount: 6,
            nonTargetCount: 14,
            duration: 10000
        }
    } else if (props.difficulty >= 4){
        state.value = {
            distanceMin: 20,
            distanceMax: 30,
            targetDistanceMin: 60,
            targetDistanceMax: 90,
            targetCount: 7,
            nonTargetCount: 18,
            duration: 10000
        }
    }

    /**
     * Populate the grid colors. This a list of very similar colors to the non-target color.
     */
    for (let i = 0; i < state.value.nonTargetCount; i++){
        nonTargetColors.value.push(
            getColorWithSimilarityInRange(
                nonTargetColor.value, 
                state.value.distanceMin, 
                state.value.distanceMax,
                false
            )
        );
    }

    /**
     * Populate our list of target colors. These are the colors that the player needs
     * to select / elmiminate.
     */
    for (let i = 0; i < state.value.targetCount; i++){
        targetColors.value.push(
            getColorWithSimilarityInRange(
                nonTargetColor.value, 
                state.value.targetDistanceMin, 
                state.value.targetDistanceMax
            ));
    }

    combinedColors.value = shuffle([...targetColors.value, ...nonTargetColors.value]);
}

variation1();

const container = ref();
const picker = ref();
const handleEnter = () => game.clock.start(state.value.duration);
const handleColorSelected = async (c: chroma.Color) => {
    if (targetColors.value.includes(c)){
        selectedCount.value++;
        if (selectedCount.value === targetColors.value.length){
            emit('next', <GameTypes.MatchCompleteData> {
                background: c
            });
            return;
        } else {
            tones.next()
        }
    } else {
        emit('fail');
    }
}

expose({
    leave: () => {
        return Promise.all([
            picker.value?.leave(),
            container?.value.leave()
        ]);
    }
})

console.log(`Odd Man Out: Variation 1, Difficulty ${props.difficulty}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    onSkip: _cache[0] || (_cache[0] = () => emit('next', { skipped: true }))
  }, {
    instruction: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ColorPicker, {
          ref_key: "picker",
          ref: picker,
          colors: combinedColors.value,
          eliminiation: true,
          onEnter: handleEnter,
          onSelect: handleColorSelected
        }, null, 8, ["colors"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})